"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCommentsInColorBlocks = exports.removeEndOfBlockComments = void 0;
const tex_syntax_1 = require("./tex-syntax");
const colorWithBlockArg = new RegExp(`(\\\\${tex_syntax_1.color})\\s*(${(0, tex_syntax_1.block)(3)})`, "g");
const blockOrCommentCharacter = `(${(0, tex_syntax_1.block)(0)}|[^\\n}])`;
const backslashEscapesAndCommentsAtEndsOfBlocks = new RegExp(`\\\\[\\\\%]|\\s*%${blockOrCommentCharacter}*}`, "g");
function removeEndOfBlockComments(tex) {
    return tex.replace(backslashEscapesAndCommentsAtEndsOfBlocks, (token) => {
        if (token[0] === "\\") {
            // token is an escaped backslash or percent sign
            return token;
        }
        // Else, token is a comment. Discard the comment and just return
        // the closing curly brace of the surrounding block (which is
        // also matched by the regex).
        return "}";
    });
}
exports.removeEndOfBlockComments = removeEndOfBlockComments;
function removeCommentsInColorBlocks(tex) {
    return tex.replace(
    // Find all occurrences of \color followed by a block...
    colorWithBlockArg, 
    // ...and fix up the contents of the block...
    (wholeMatch) => {
        return removeEndOfBlockComments(wholeMatch);
    });
}
exports.removeCommentsInColorBlocks = removeCommentsInColorBlocks;
